// SortButton.jsx
import React from 'react';
import PropTypes from 'prop-types';
import './SortButton.scss';

const SortButton = ({ field, label, sortConfig, onSortChange }) => {
    const handleClick = () => {
        if (!sortConfig || sortConfig.field !== field) {
            // First click - sort ascending
            onSortChange({ field, order: 'asc' });
        } else if (sortConfig.order === 'asc') {
            // Second click - switch to descending
            onSortChange({ field, order: 'desc' });
        } else {
            // Third click - reset sort
            onSortChange(null);
        }
    };

    const getSortIconClass = () => {
        if (!sortConfig || sortConfig.field !== field) {
            return "fa fa-sort";
        }
        return sortConfig.order === 'asc' 
            ? "fa-sort-asc"
            : "fa-sort-desc";
    };

    function getSortAriaLabel() {
        if (!sortConfig || sortConfig.field !== field) {
            return '(not sorted)';
        }
        return sortConfig.order === 'asc' ? '(ascending)' : '(descending)';
    }


    return (
        <button 
            className="sort-button" 
            type="button"
            onClick={handleClick}
            aria-label={`Sort by ${field} ${getSortAriaLabel()}`}
        >
            {label}
            &nbsp;
             <i className={"fa " +getSortIconClass()} aria-hidden="true" />
            
        </button>
    );
};

SortButton.propTypes = {
    field: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    sortConfig: PropTypes.shape({
        field: PropTypes.string,
        order: PropTypes.oneOf(['asc', 'desc'])
    }),
    onSortChange: PropTypes.func.isRequired
};

export default SortButton;
